/*
 global webkit
*/

import getWindow from '../../get-window';

// Platforms
import { isIOSApp, isAndroidApp } from '..';

const $window = getWindow() || {};

// Platform handlers
export const handlers = {
  noop: () => {},
  iOS: (handler, message) => {
    $window.webkit &&
      $window.webkit.messageHandlers &&
      $window.webkit.messageHandlers[handler] &&
      $window.webkit.messageHandlers[handler].postMessage(message);
  },
  Android: (handler, message) => {
    $window.AnalyticsWebInterface &&
      $window.AnalyticsWebInterface.logEvent &&
      $window.AnalyticsWebInterface.logEvent(handler, message);
  }
};

// Actual handler
const MessageHandler =
  (isIOSApp() && handlers.iOS) ||
  (isAndroidApp() && handlers.Android) ||
  handlers.noop;

export default MessageHandler;
